// extracted by mini-css-extract-plugin
export default {"element":"AnalyticsElement_element__R9Jil","wrapper":"AnalyticsElement_wrapper__E75l7","title":"AnalyticsElement_title__xL3jH","count":"AnalyticsElement_count__UlpPU"};